// extracted by mini-css-extract-plugin
export default {"layout":"DataVerificationStatusPopup__layout--oRS","innerContent":"DataVerificationStatusPopup__innerContent--3wS","info":"DataVerificationStatusPopup__info--13i"};